import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TransportOption } from '../../transport-options.model';

export class TransportOptionEditorDialogData {
  transportOption: TransportOption;
}

@Component({
  selector: 'app-transport-option-editor-loading',
  templateUrl: './transport-option-editor-loading.component.html',
  styleUrls: ['./transport-option-editor-loading.component.scss']
})
export class TransportOptionEditorLoadingComponent implements OnInit {

  @Input() transportOption: TransportOption;

  @Output() changed = new EventEmitter();

  keys = Object.keys;

  optionFormGroup = new FormGroup({});

  optionValid = false;

  constructor() {

    this.optionFormGroup.addControl('amountOfPallettesMandatory', new FormControl(null, []));
    this.optionFormGroup.addControl('amountOfBoxesMandatory', new FormControl(null, []));
    this.optionFormGroup.addControl('amountInKilogrammMandatory', new FormControl(null, []));
    this.optionFormGroup.addControl('amountInLiterMandatory', new FormControl(null, []));
    this.optionFormGroup.addControl('amountOthersMandatory', new FormControl(null, []));
    this.optionFormGroup.addControl('amountMandatoryInTerminal', new FormControl(null, []));
    this.optionFormGroup.addControl('amountMandatoryInTime', new FormControl(null, []));

    this.optionFormGroup.valueChanges.subscribe(
      value => {
        if (this.optionFormGroup.dirty) {
          this.transportOption.amountOfPallettesMandatory = this.optionFormGroup.controls.amountOfPallettesMandatory.value;
          this.transportOption.amountOfBoxesMandatory = this.optionFormGroup.controls.amountOfBoxesMandatory.value;
          this.transportOption.amountInKilogrammMandatory = this.optionFormGroup.controls.amountInKilogrammMandatory.value;
          this.transportOption.amountInLiterMandatory = this.optionFormGroup.controls.amountInLiterMandatory.value;
          this.transportOption.amountOthersMandatory = this.optionFormGroup.controls.amountOthersMandatory.value;
          this.transportOption.amountMandatoryInTerminal = this.optionFormGroup.controls.amountMandatoryInTerminal.value;
          this.transportOption.amountMandatoryInTime = this.optionFormGroup.controls.amountMandatoryInTime.value;

          this.changed.emit();
        }
      }
    );
  }

  public ngOnInit() {

    const formdata: any = {};
    formdata.amountOfPallettesMandatory = this.transportOption.amountOfPallettesMandatory;
    formdata.amountOfBoxesMandatory = this.transportOption.amountOfBoxesMandatory;
    formdata.amountInKilogrammMandatory = this.transportOption.amountInKilogrammMandatory;
    formdata.amountInLiterMandatory = this.transportOption.amountInLiterMandatory;
    formdata.amountOthersMandatory = this.transportOption.amountOthersMandatory;
    formdata.amountMandatoryInTerminal = this.transportOption.amountMandatoryInTerminal;
    formdata.amountMandatoryInTime = this.transportOption.amountMandatoryInTime;

    this.optionFormGroup.reset(formdata);

  }

}
